/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Country } from '../models/country';

@Injectable({
  providedIn: 'root',
})
export class CountriesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCountries
   */
  static readonly GetCountriesPath = '/api/v1/Countries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCountries$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountries$Plain$Response(params?: {
    name?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Country>>> {

    const rb = new RequestBuilder(this.rootUrl, CountriesService.GetCountriesPath, 'get');
    if (params) {
      rb.query('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Country>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCountries$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountries$Plain(params?: {
    name?: string;
  },
  context?: HttpContext

): Observable<Array<Country>> {

    return this.getCountries$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Country>>) => r.body as Array<Country>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCountries$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountries$Json$Response(params?: {
    name?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Country>>> {

    const rb = new RequestBuilder(this.rootUrl, CountriesService.GetCountriesPath, 'get');
    if (params) {
      rb.query('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Country>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCountries$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountries$Json(params?: {
    name?: string;
  },
  context?: HttpContext

): Observable<Array<Country>> {

    return this.getCountries$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Country>>) => r.body as Array<Country>)
    );
  }

}
